// extracted by mini-css-extract-plugin
module.exports = {"big_container":"styles_big_container__3oFzW","content_left":"styles_content_left__1Bu53","data":"styles_data__2ic8-"};